import Vue from 'vue';
import _ from 'lodash';
import operationService from '@/features/operation/service';
import { createActionHelpers } from 'vuex-loading';

export const SELECT_OPERATION = 'selectOperationCommit';
export const SELECT_CESIONES = 'selectCesionesCommit';
export const BUILD_MAP = 'buildMapCommit';
export const CLEAR_MODULE = 'clearCesionesModule';
export const UPDATE_DOCUMENT_CESION = 'updateDocumentCesion';

export const initOperationCesionesAction = 'initOperationCesionesAction';
export const initModuleAction = 'initModuleAction';
export const upsertCesionAction = 'upsertCesionAction';
export const removeCesionAction = 'removeCesionAction';
export const updateOperationAction = 'updateOperationAction';
export const updateDocumentCesionAction = 'updateDocumentCesionAction';

export const selectedOperationGetter = 'selectedOperation';
export const selectedCesionesGetter = 'selectedCesiones';
export const inversoresMapGetter = 'inversoresMap';
export const instanciaLetrasMapGetter = 'instanciaLetrasMap';
export const documentCesionGetter = 'documentCesionGetter';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

async function buildMaps(operation, cesiones, commit, rootGetters) {
  const inversoresMap = {};
  const instanciaLetrasMap = {};
  if (_.has(operation, 'letras') && _.isArray(operation.letras)) {
    operation.letras.forEach((letraOperation) => {
      if (_.isNil(instanciaLetrasMap[letraOperation])) {
        instanciaLetrasMap[letraOperation] = [];
      }
    });
  }
  cesiones.forEach((cesion) => {
    if (Array.isArray(cesion.letras)) {
      cesion.letras.forEach((idLetra) => {
        const letra = rootGetters['instanciaLetraCesion_model/entitiesGetter'][idLetra];
        if (!_.isNil(letra)) {
          if (_.isNil(instanciaLetrasMap[letra.letra])) {
            instanciaLetrasMap[letra.letra] = [];
          }
          instanciaLetrasMap[letra.letra].push(letra.id);
        }
      });
    }
    if (cesion.inversor && cesion.inversor !== '') {
      if (!Array.isArray(inversoresMap[cesion.inversor])) {
        inversoresMap[cesion.inversor] = [];
      }
      inversoresMap[cesion.inversor].push(cesion.id);
    }
  });
  commit(BUILD_MAP, { mapName: 'inversoresMap', map: inversoresMap });
  commit(BUILD_MAP, { mapName: 'instanciaLetrasMap', map: instanciaLetrasMap });
}

async function doCesion(operation, entity, commit, dispatch, rootGetters) {
  const cesion = await dispatch('cesion_model/upsertEntityAction', entity, { root: true });
  let newCesiones;
  if (Array.isArray(operation.cesiones) && operation.cesiones.indexOf(cesion.id) > -1) {
    newCesiones = operation.cesiones;
  } else if (Array.isArray(operation.cesiones)) {
    newCesiones = [...operation.cesiones, cesion.id];
  } else {
    newCesiones = [cesion.id];
  }
  const cesiones = newCesiones.map(id => rootGetters['cesion_model/entitiesGetter'][id]);
  buildMaps(operation, cesiones, commit, rootGetters);
  commit(SELECT_CESIONES, newCesiones);
  const op = Vue._.merge({}, operation, { cesiones: newCesiones });
  await dispatch('operation_model/upsertEntityAction', op, { root: true });
  return cesion;
}

const initState = {
  selectedOperation: null,
  selectedCesiones: [],
  inversoresMap: {},
  instanciaLetrasMap: {},
  document: {},
};

export default {
  namespaced: true,
  state: initState,
  mutations: {
    [SELECT_OPERATION](state, payload) {
      state.selectedOperation = payload;
    },
    [SELECT_CESIONES](state, payload) {
      state.selectedCesiones = payload;
    },
    [BUILD_MAP](state, payload) {
      const { mapName, map } = payload;
      state[mapName] = map;
    },
    [CLEAR_MODULE](state) {
      Object.assign(state, Vue._.cloneDeep(initState));
    },
    [UPDATE_DOCUMENT_CESION](state, payload) {
      Vue.set(state, 'document', payload);
    },
  },
  actions: {
    async [initOperationCesionesAction]({ commit, dispatch, rootGetters }, operationId) {
    //  startLoading(dispatch, 'init cesiones');
      const operations = await dispatch('operation_model/fetchAction', { id: operationId }, { root: true });
      const operation = operations.entities[0];
      const letrasOperationResult = await dispatch('instanciaLetra_model/fetchAction', { uuidFilter: {
        path: 'uuid',
        operator: '=',
        value: operation.id,
        parent: 'node--operation',
        parentProperty: 'letras_operation',
      } }, { root: true });
      const letrasOperationIds = letrasOperationResult.entities.map(e => e.id);
      await dispatch('instanciaLetraCesion_model/fetchAction', { uuidFilter: {
        modelName: 'letraOperation',
        path: 'letra_operacion.uuid',
        operator: 'IN',
        value: letrasOperationIds,
      } }, { root: true });
      commit(SELECT_OPERATION, operation);
      let localFound = true;
      if (Array.isArray(operation.cesiones)) {
        operation.cesiones.forEach((cesionId) => {
          if (!rootGetters['cesion_model/entitiesGetter'][cesionId]) {
            localFound = false;
          }
        });
      }
      if (!localFound) {
        await dispatch('cesion_model/fetchAction', { uuidFilter: {
          path: 'uuid',
          operator: '=',
          value: operation.id,
          parent: 'node--operation',
          parentProperty: 'cesiones',
        } }, { root: true });
      }
      const cesiones = [];
      if (Array.isArray(operation.cesiones) && operation.cesiones.length > 0) {
        operation.cesiones.forEach(cesionId => cesiones.push(cesionId));
        await dispatch('instanciaLetraCesion_model/fetchAction', { uuidFilter: {
          path: 'uuid',
          operator: 'IN',
          value: cesiones,
          parent: 'node--cesion',
          parentProperty: 'letras_cesion',
        } }, { root: true });
      }
      buildMaps(operation, cesiones, commit, rootGetters);
      commit(SELECT_CESIONES, cesiones);
     // endLoading(dispatch, 'init cesiones');
    },
    // eslint-disable-next-line consistent-return
    async [upsertCesionAction]({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'upsert cesion');
      const { operation, entity, document } = payload;
      const user = rootGetters.user;
      const cesiones = operation.cesiones ? operation.cesiones : [];
      if (entity.title === '') {
        entity.title = `${operation.title} - Cesion - ${cesiones.length}`;
      }
      if (entity.inversor && entity.inversor.id) {
        entity.inversor = entity.inversor.id;
      }
      if (document) {
        const documentToSave = {
          user,
          operation,
          document,
          title: document.title,
          file: document.file,
        };
        let documentSaved;
        try {
          documentSaved = await dispatch('documents/saveDocumentAction', documentToSave, { root: true });
        } catch (error) {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'upsert cesion');
        }
        if (documentSaved) {
          entity.contrato = documentSaved.id;
          if (documentSaved && documentSaved.file && documentSaved.file !== '') {
            const imageFile = rootGetters['fileImage_model/entitiesGetter'][documentSaved.file];
            const documentFile = rootGetters['fileDocument_model/entitiesGetter'][documentSaved.file];
            let fileServer;
            if (!_.isNil(imageFile)) {
              fileServer = imageFile;
            } else if (!_.isNil(documentFile)) {
              fileServer = documentFile;
            }
            if (fileServer) {
              const fileToSave = {
                title: documentSaved.title,
                url: fileServer.url,
              };
              commit(UPDATE_DOCUMENT_CESION, fileToSave);
            }
          }
        }
      }
      if (entity.letras && entity.letras.length > 0) {
        const letrasIds = [];
        return entity.letras.reduce((promise, letra) =>
          promise.then(() => dispatch('instanciaLetraCesion_model/upsertEntityAction', letra, { root: true })
          .then(res => letrasIds.push(res.id))), Promise.resolve()).then(() => {
            entity.letras = letrasIds;
            return doCesion(operation, entity, commit, dispatch, rootGetters)
              .then(() => {
                endLoading(dispatch, 'upsert cesion');
                dispatch('initOperationCesionesAction', operation.id);
              });
          }).catch((error) => {
            dispatch('updateErrorOverlay', error, { root: true });
            endLoading(dispatch, 'upsert cesion');
          });
      }
      endLoading(dispatch, 'upsert cesion');
      return doCesion(operation, entity, commit, dispatch, rootGetters);
    },
    [removeCesionAction]({ commit, dispatch }, payload) {
      const { operation, entity } = payload;
      const cesiones = operation.cesiones ? operation.cesiones : [];
      const newCesiones = cesiones.filter(id => id !== entity.id);
      const op = Vue._.merge({}, operation, { cesiones: newCesiones });
      return dispatch('operation_model/upsertEntityAction', op, { root: true });
    },
    async [updateDocumentCesionAction]({ commit, dispatch, rootGetters }, id) {
      if (!id) {
        commit(UPDATE_DOCUMENT_CESION, {});
      } else {
        const files = await dispatch('document_model/fetchAction', { id }, { root: true });
        if (files && files.entities && Array.isArray(files.entities)) {
          const document = files.entities[0];
          if (document && document.file && document.file !== '') {
            let fileServer;
            try {
              fileServer = await dispatch('fileImage_model/fetchAction', { id: document.file }, { root: true });
            } catch (error) {
              fileServer = await dispatch('fileDocument_model/fetchAction', { id: document.file }, { root: true });
            }
            if (fileServer && fileServer.entities) {
              const file = fileServer.entities[0];
              const fileToSave = {
                title: document.title,
                url: file.url,
              };
              commit(UPDATE_DOCUMENT_CESION, fileToSave);
            }
          }
        }
      }
    },
    [updateOperationAction]({ commit, state }, payload) {
      const cesiones = [];
      state.ids.forEach((c) => {
        if (c !== 'dummy' && c !== '') {
          cesiones.push(c);
        }
      });
      const operation = {
        id: payload.id,
        cesiones,
      };
      return operationService.updateOperation(operation);
    },
  },
  getters: {
    [selectedOperationGetter]: state => state.selectedOperation,
    [selectedCesionesGetter]: state => state.selectedCesiones,
    [inversoresMapGetter]: state => state.inversoresMap,
    [instanciaLetrasMapGetter]: state => state.instanciaLetrasMap,
    [documentCesionGetter]: state => state.document,
  },
};



// WEBPACK FOOTER //
// ./src/features/cesiones/store.js